import { createSlice } from "@reduxjs/toolkit";
import { fetchUserDetails, fetchLatestPermissions } from './thunk';
import { LoginState } from "./types";

// export const initialState = {
//   user: {},
//   error: "",
//   loading: false,
//   isUserLogout: false,
//   errorMsg: false,
// };
export const initialState: LoginState = {
  user: null, // not {} — this makes TS allow optional checks
  error: null,
  loading: false,
  isUserLogout: false,
  errorMsg: false,
  permissionsLoading: false, // Start as false, will be set to true when fetching
  permissionsFetched: false, // Track if permissions have been fetched at least once
  permissionsError: null, // Store error message if permissions fetch fails
};

const loginSlice = createSlice({
  name: "login",
  initialState,
  reducers: {
    apiError(state, action) {
      // state.error = action.payload.data;
      state.error = action.payload;
      state.loading = true;
      state.isUserLogout = false;
      state.errorMsg = true;
    },
    loginSuccess(state, action) {
      // Store the user data (with permissions) from the response
      // action.payload is the entire response: { status, success, message, data }
      // We need to store action.payload.data which contains the user object with permissions
      state.user = action.payload?.data || action.payload;
      state.loading = false;
      state.errorMsg = false;
      // console.log(
      //   `state: ${JSON.stringify(state)} , action: ${JSON.stringify(action)}`
      // );
      // console.log("state.user", state.user);
    },
    logoutUserSuccess(state, action) {
      state.isUserLogout = true;
    },
    reset_login_flag(state) {
      state.error = "";
      state.loading = false;
      state.errorMsg = false;
    },
    resetPermissionsState(state) {
      state.permissionsLoading = false;
      state.permissionsFetched = false;
      state.permissionsError = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserDetails.fulfilled, (state, action) => {
        state.user = action.payload.data;
      })
      .addCase(fetchLatestPermissions.pending, (state) => {
        state.permissionsLoading = true;
        state.permissionsError = null;
      })
      .addCase(fetchLatestPermissions.fulfilled, (state, action) => {
        if (state.user) {
          // action.payload is already the permissions array from the thunk
          state.user.permissions = action.payload;
        }
        state.permissionsLoading = false;
        state.permissionsFetched = true;
        state.permissionsError = null;
      })
      .addCase(fetchLatestPermissions.rejected, (state, action) => {
        console.error("Failed to fetch permissions:", action.payload);
        state.permissionsLoading = false;
        state.permissionsFetched = true; // Mark as fetched even on error to prevent infinite loading
        state.permissionsError = (action.payload as string) || "Failed to load permissions";
      });
  },
});

export const { apiError, loginSuccess, logoutUserSuccess, reset_login_flag, resetPermissionsState } =
  loginSlice.actions;

export default loginSlice.reducer;
